import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { CouldNotLoadSurveyComponent } from './could-not-load-survey/could-not-load-survey.component';
import { StudentCompletedSurveyComponent } from './student-completed-survey/student-completed-survey.component';
import { MaintenanceComponent } from './maintenance/maintenance.component';

const routes: Routes = [
	//Wild Card Route for 404 request
	{ path: '', redirectTo: '/modules/campaigns', pathMatch: 'full' },
	{ path: 'maintenance', pathMatch: 'full', component: MaintenanceComponent },
	{ path: 'page-not-found', pathMatch: 'full', component: PageNotFoundComponent },
	{ path: 'student-completed-survey', pathMatch: 'full', component: StudentCompletedSurveyComponent },
	{ path: 'could-not-load-survey', pathMatch: 'full', component: CouldNotLoadSurveyComponent },
	{
		path: 'modules',
		loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule),
	},
	{ path: '**', redirectTo: 'page-not-found', pathMatch: 'full' }
];

@NgModule({
	imports: [ 
		RouterModule.forRoot(routes, { useHash: true }) 
	],
	exports: [ RouterModule ]
})
export class AppRoutingModule {}
